<template>
  <div>
    <div class="top_div">
      <img class="home_banner" src="../../../static/img/img_safe_top_bg.png" />
    </div>
    <div class="tip-div">
      <div class="tip-item" @click="changeItemPosition(1)" @mouseenter="changeHoverPosition(1)" @mouseleave="changeHoverPosition(0)">
        <img  src="../../../static/img/ic_safe_1.png" v-show="itemPosition!=1&&hoverPosition!=1"/>
        <img  src="../../../static/img/ic_safe_1_2.png" v-show="itemPosition==1||hoverPosition==1"/>
        <p :class="itemPosition==1?'tip-title-hover':'tip-title'">安防护卫</p>
        <p :class="itemPosition==1?'tip-subtitle-hover':'tip-subtitle'">SERVICE ITEMS</p>
      </div>
      <div class="tip-item" @click="changeItemPosition(2)" @mouseenter="changeHoverPosition(2)" @mouseleave="changeHoverPosition(0)">
        <img  src="../../../static/img/ic_safe_2.png" v-show="itemPosition!=2&&hoverPosition!=2"/>
        <img  src="../../../static/img/ic_safe_2_2.png" v-show="itemPosition==2||hoverPosition==2"/>
        <p :class="itemPosition==2?'tip-title-hover':'tip-title'">消防服务</p>
        <p :class="itemPosition==2?'tip-subtitle-hover':'tip-subtitle'">FIRE SERVICE</p>
      </div>
      <div class="tip-item" @click="changeItemPosition(3)" @mouseenter="changeHoverPosition(3)" @mouseleave="changeHoverPosition(0)">
        <img  src="../../../static/img/ic_safe_3.png" v-show="itemPosition!=3&&hoverPosition!=3"/>
        <img  src="../../../static/img/ic_safe_3_2.png" v-show="itemPosition==3||hoverPosition==3"/>
        <p :class="itemPosition==3?'tip-title-hover':'tip-title'">保安培训</p>
        <p :class="itemPosition==3?'tip-subtitle-hover':'tip-subtitle'">RITY TRAINING</p>
      </div>
      <div class="tip-item" @click="changeItemPosition(4)" @mouseenter="changeHoverPosition(4)" @mouseleave="changeHoverPosition(0)">
        <img  src="../../../static/img/ic_safe_4.png" v-show="itemPosition!=4&&hoverPosition!=4"/>
        <img  src="../../../static/img/ic_safe_4_2.png" v-show="itemPosition==4||hoverPosition==4"/>
        <p :class="itemPosition==4?'tip-title-hover':'tip-title'">物业服务</p>
        <p :class="itemPosition==4?'tip-subtitle-hover':'tip-subtitle'">COMMERCIAL SERVICE</p>
      </div>
      <div class="tip-item" @click="changeItemPosition(5)" @mouseenter="changeHoverPosition(5)" @mouseleave="changeHoverPosition(0)">
        <img src="../../../static/img/ic_safe_5.png" v-show="itemPosition!=5&&hoverPosition!=5"/>
        <img src="../../../static/img/ic_safe_5_2.png" v-show="itemPosition==5||hoverPosition==5"/>
        <p :class="itemPosition==5?'tip-title-hover':'tip-title'">安检设备租售</p>
        <p :class="itemPosition==5?'tip-subtitle-hover':'tip-subtitle'">RENTAL AND SALES</p>
      </div>
    </div>

    <div class="honor_div2" id="honor-div-1">
      <div class="honor-sub-1">
        <div class="honor-sub-left-div">
          <img src="../../../static/img/img_safe_1.png" />
        </div>
        <div class="honor-sub-right-div">
          <p class="txt-heading">安防保卫</p>
          <el-collapse v-model="activeName1" accordion class="collapse-div">
            <el-collapse-item title="随身护卫" name="1">
              <template slot="title">随身护卫<i :class="judgeActive1('1')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                主要为商界高层、文艺界、体育界以及其他社会知名人士提供高级安保服务，提供全程化安全护卫方案，通过风险预警、贴身护卫、定点守护等方式为客户人身安全提供有力保障。
              </p>
            </el-collapse-item>
            <el-collapse-item title="大型活动安保" name="2">
              <template slot="title">大型活动安保<i :class="judgeActive1('2')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                宏邦保安配有专业的勤务指挥和保障车辆，执勤防护装备精良，可为各类文艺演出、艺术品拍卖、体育赛事、会议展览等大型活动提供现场安保服务。维护现场秩序，保护场地安全。
              </p>
            </el-collapse-item>
            <el-collapse-item title="安全检查" name="3">
              <template slot="title">安全检查<i :class="judgeActive1('3')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                宏邦保安拥有一支专业的安检团队，经过严格的安检职业技能培训，并配备专业全套的安全检查设备。为各类大型活动群众性活动及公共交通行业提供专业的防暴力、防爆炸等安全检查服务。
              </p>
            </el-collapse-item>
            <el-collapse-item title="企业安防" name="4">
              <template slot="title">企业安防<i :class="judgeActive1('4')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                面向政府机关、金融机构、企事业单位、独资合资企业等其他场所提供门卫安全、责任区域安全巡逻、防盗、防火检查、其他应客户要求的安全防范。做到高效、高质、高标准，为客户提供专业安防服务。
              </p>
            </el-collapse-item>
            <el-collapse-item title="守护巡逻" name="5">
              <template slot="title">守护巡逻<i :class="judgeActive1('5')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                为各大事企单位、商场、社区等提供安防巡逻服务，对特定区域进行巡视检查、警戒，联合相关部门以达到震慑不法分子、及时发现制止不法行为、消除安全隐患、防止危险事件发生等安防目的。
              </p>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <div class="honor_div"  id="honor-div-2">
      <div class="honor-sub-2">
        <div  class="honor-sub-left-div">
          <p class="txt-heading">消防服务</p>
          <p class="txt-content">
            宏邦为客户提供消防服务，员工具有多年检测、维保、评估专业经验，能够严格按照行业规范和相关技术要求开展消防设施及电气防火检测、消防设施维护保养、消防安全评估工作。与多家企业达成合作关系，为企业提供消防服务，让企业更加安心生产。企业专职消防队担负着企业消防灭火抢险救援等重要职能，是企业安全生产的最后一道防线，也是维护职工住宅区和公共场所消防安全的重要力量。
          </p>
          <p class="txt-content">
            宏邦在消防领域中积累了丰富的行业经验，以及一
            批业务精通、经验丰富、技术娴熟、责任心强的专业队伍。客户第一是公司的服务宗旨。质量可靠、诚信经营、高质服务是我们对客户负责的态度。开拓创新，勇于挑战，秉承路有多远，我们的服务就有多远的服务理念，坚持以策略为先导，以品牌服务为核心，为广大客户提供全方位的服务。
          </p>
        </div>
        
        <div  class="honor-sub-right-div">
          <img src="../../../static/img/img_safe_2.png" />
        </div>
      </div>
    </div>
    <div class="honor_div2"  id="honor-div-3">
      <div class="honor-sub-3">
        <div  class="honor-sub-left-div">
          <img src="../../../static/img/img_safe_3.png" />
        </div>

        <div  class="honor-sub-right-div">
          <p class="txt-heading">保安培训</p>
          <p class="txt-content">
            宏邦从事多年保安培训工作，具有丰富的教学培训及管理经验，能够胜任岗前专业及各级层职业等级培训的需要
            ,
            此外，为整合系统资源，发挥专业优势扩大培训规模，宏邦保安在宁波市不同区域不同方位与多家培训学校达成合作协议接受培训学校的统一指导和监督，就近为各保安服务企业提供培训业务支持。<br/>
            保安培训是公安机关加强保安监管、规范保安服务活动、提高保安队伍综合素质、提升保安从业人员服务能力和水平的有力抓手，将对促进保安服务专业化、规范化、职业化发展，增强保安职业吸引力和保安队伍凝聚力发挥重要作用。适应新形势、新发展的技能要求，以更好的适应新时代保安事业发展对保安员进行多种技能、适应多个岗位的新要求进行专业保安培训。
          </p>
          <p class="txt-heading2">设施设备</p>
          <p class="txt-content">
            宏邦拥有宽敞、舒适的教学、实训场地和考试场所，拥有可以容纳100多名学员的阶梯教室2个，容纳80名学员的电化教室2个，及1个1000m²的军事实训场地。配备齐全的消防、技防、保卫体技能等训练器械器材、设施设备。
          </p>
        </div>
      </div>
    </div>
    <div class="honor_div"  id="honor-div-4">
      <div class="honor-sub-4">
        <div  class="honor-sub-left-div">
          <p class="txt-heading">物业服务</p>
          <el-collapse v-model="activeName2" accordion class="collapse-div">
            <el-collapse-item title="一站式管理服务" name="1">
              <template slot="title">一站式管理服务<i :class="judgeActive2('1')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                主要为商界高层、文艺界、体育界以及其他社会知名人士提供高级安保服务，提供全程化安全护卫方案，通过风险预警、贴身护卫、定点守护等方式为客户人身安全提供有力保障。
              </p>
            </el-collapse-item>
            <el-collapse-item title="企事业单位保洁服务" name="2">
              <template slot="title">企事业单位保洁服务<i :class="judgeActive2('2')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                宏邦拥有完善的物业后勤保障人员可为客户量身定制相应的物业后勤服务
                , 根据客户要求，结合项目实际情况 ,
                按照客户属性定制整体解决方案物业项目整体运营管理，机电设备设施的安装保养与维修、物业保洁等
                ,
                以“诚实守信，客户至上，以人为本致精致诚”为核心，提供全程无忧服务。
              </p>
            </el-collapse-item>
            <el-collapse-item title="设施运维管理服务" name="3">
              <template slot="title">设施运维管理服务<i :class="judgeActive2('3')!==-1?'downArrow2':'downArrow1'"></i></template>
              <p class="txt-content">
                根据客户需求，基于以设备运维平台为核心载体的设备运维标准体系，为客户提供针对性的智慧、高效、专业的平台运维，实现设备全生命周期一体化优质服务，提升设备可使用价值。
              </p>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div  class="honor-sub-right-div">
          <img src="../../../static/img/img_safe_4.png" />
        </div>
      </div>
    </div>
    <div class="honor_div2"  id="honor-div-5">
      <div class="honor-sub-3">
        <div class="honor-sub-left-div">
          <img src="../../../static/img/img_safe_5.png" />
        </div>

        <div  class="honor-sub-right-div">
          <p class="txt-heading">安检设备租售</p>
          <p class="txt-content">
            为满足客户大型会议、体育赛事运动会、演唱会、会展等活动的临时需要宏邦保安提供以下防爆安检设备租赁业务
            , X 光射线行李检查设备、便捷式 X
            光机、手持金属探测器、金属探测安检门、车底安全检查扫描系统等防爆安检设备
            , 设备全部通过欧盟 CE 认证和 ISO9001 质量管理体系认证，符合 ISO14001
            环境管理体系要求。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import safeView1 from "../view/SafeView1.vue";
import safeView2 from "../view/SafeView2.vue";

export default {
  components: {
    safeView1,
    safeView2,
  },
  data() {
    return {
      Detail: [],
      itemPosition: 1,
      hoverPosition: 1,
      activeName1: "1",
      activeName2: "1",
    };
  },
  mounted() {
    this.Init();
    var param = this.$route.query.param;
    if(param){
      console.log("param:" + param);
      this.navtoPartPath(param);
    }else{
      window.scrollTo(0, 0);
    }
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {

    //监听路由变化
    $route(to, from) {
      this.Init();
      console.log(to.path);
      var param = this.$route.query.param;
      console.log("param:" + param);
      if (param) {
        setTimeout(() => {
            // document.getElementById(path).scrollIntoView();
          this.navtoPartPath(param);
        }, 500);
      }else{
        window.scrollTo(0, 0);
      }
    },
  },
  methods: {
    Init() {
      this.getDetail();
    },
    changeItemPosition(position){
      if(position==2){
        this.navtoPartPath('honor-div-2');
      }else if(position==3){
        this.navtoPartPath('honor-div-3');
      }else if(position==4){
        this.navtoPartPath('honor-div-4');
      }else if(position==5){
        this.navtoPartPath('honor-div-5');
      }else{
        this.navtoPartPath('honor-div-1');
      }
      this.itemPosition = position;

    },
    changeHoverPosition(position){
      this.hoverPosition = position;
    },
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    scrollNavto(path, name) {
      this.$router.push({
        path: `${path}`,
        query: { param: name },
      });
    },
    navtoPartPath(path) {
      if (path) {
        // setTimeout(() => {
        //   document.getElementById(path).scrollIntoView();
        // }, 500);
        document.getElementById(path).scrollIntoView(true);
      }
    },
        //判断是否打开
    judgeActive1(data){
      return  this.activeName1.indexOf(data)
    },
    judgeActive2(data){
      return  this.activeName2.indexOf(data)
    },
    getDetail() {
      this.$axios.get("api/contacts/company").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.Detail = response.data.data;
          }
        }.bind(this)
      );
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.top_div {
  height: 68.5rem;
  width: 100%;
  z-index: -1;
  position: relative;
}

.home_banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.tip-div {
  bottom: -8rem;
  right: 0;
  left: 0;
  background: white;
  padding: 3rem 0;
  margin: -10rem auto 8rem auto;
  width: 70vw;
  box-shadow: 3px 3px 10px 1px rgba(100, 100, 100, 0.1);
  border-radius: 6px;
  display: flex;
  justify-content: space-evenly;

  .tip-item {
    text-align: center;
    cursor: pointer;

    .tip-title {
      margin-top:1.8rem;
      color: var(--COLORE67);
      font-family: medium;
      font-size: 1.8rem;
      margin-bottom: 0;
    }
    .tip-title-hover {
      margin-top:1.8rem;
      color: var(--textBlue);
      font-family: medium;
      font-size: 1.8rem;
      margin-bottom: 0;
    }

    .tip-subtitle {
      color: var(--COLORE6750);
      font-family: medium;
      font-size: 1.6rem;
      margin-bottom: 0;
    }
    .tip-subtitle-hover {
      color: var(--textBlue);
      font-family: medium;
      font-size: 1.6rem;
      margin-bottom: 0;
    }

    .tip-num {
      color: var(--COLORE67);
      font-family: DIN-Bold;
      font-size: 2.2rem;
      margin-bottom: 0;
    }

    img{
      width:5rem;
      height:5rem;
      object-fit: contain;
    }
  }

  .tip-item:hover {
    .tip-title {
      color: var(--textBlue);
    }
    .tip-subtitle {
      color: var(--textBlue);
    }
  }
}

.heading_div {
  margin: 15rem 0 0 10rem;
  width: 63rem;
}

.heading {
  font-size: 3rem;
  color: var(--textBlack);
  text-align: left;
  font-family: regular;
}

.tv_content {
  font-size: 1.8rem;
  color: var(--textBlack);
  text-align: justify;
  font-family: light;
}

.icon_div {
  display: flex;
  color: var(--textGary80);
  font-size: 1.8rem;
  justify-content: space-evenly;
  margin: 8rem 35rem 14rem;

  .icon_item {
    background-image: url('../../../static/img/icon_bg.png');
    width: 18rem;
    height: 18rem;
  }

  img {
    width: 5rem;
    height: 5rem;
    margin: 4rem auto 1rem;
  }
}

.honor_div {
  display: flex;
  flex-direction: row-reverse;
  background: var(--divGaryE250);
  //padding: 3rem 0;
  

  p {
    margin: 0;
  }

  
  /deep/ .el-collapse-item__header.is-active {
    color: var(--textBlue);
    padding-bottom: 1rem;
  }

  /deep/ .el-collapse-item__header.focusing:focus:not(:hover) {
    color: var(--textBlue);
  }

  /deep/ .el-collapse-item__header {
    color: var(--COLORE47);
    font-family: medium;
    font-size: 2rem;
    padding-bottom: 2rem;
    padding-top: 1rem;
    background-color: transparent;
  }
  /deep/ .el-collapse-item__wrap{
    background-color: transparent;
  }

  .collapse-div {
    margin-top: 4rem;
  }

  .txt-heading {
    font-family: medium;
    color: var(--textBlue);
    font-size: 4rem;
    margin-bottom: 4rem;
  }

  .txt-heading2 {
    font-family: medium;
    color: var(--textBlue);
    font-size: 2rem;
    margin-top:3rem;
  }

  .txt-content {
    font-family: regular;
    color: var(--COLORE66);
    font-size: 1.8rem;
    line-height:1.77;
  }

  .honor_sub {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  img {
    width: 86rem;
    height: 48rem;
  }

  .img2 {
    width: 36rem;
    height: 28rem;
  }
}

.honor_div2 {
  display: flex
  background: white;
  //padding: 3rem 0;
  background-image:url('../../../static/img/img_safe_bg.png');
  background-repeat: no-repeat;
  background-position: right, center;
  background-size: contain;
  p {
    margin: 0;
  }

  /deep/ .el-collapse-item__header.is-active {
    color: var(--textBlue);
    padding-bottom: 1rem;
  }

  /deep/ .el-collapse-item__header.focusing:focus:not(:hover) {
    color: var(--textBlue);
  }

  /deep/ .el-collapse-item__header {
    color: var(--COLORE47);
    font-family: medium;
    font-size: 2rem;
    padding-bottom: 2rem;
    padding-top: 1rem;
    background-color: transparent;
  }

  /deep/ .el-collapse-item__wrap{
    background-color: transparent;
  }
  .collapse-div {
    margin-top: 4rem;
  }

  .txt-heading {
    font-family: medium;
    color: var(--textBlue);
    font-size: 4rem;
    margin-bottom: 4rem;
  }

  .txt-heading2 {
    font-family: medium;
    color: var(--textBlue);
    font-size: 2rem;
    margin-top:3rem;
  }

  .txt-content {
    font-family: regular;
    color: var(--COLORE66);
    font-size: 1.8rem;
    line-height:1.77;
  }

  .honor_sub {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  img {
    width: 100%;
    height: 48rem;
    object-fit: cover;
  }

  .img2 {
    width: 36rem;
    height: 28rem;
  }
}

.honor-sub-1{
  margin:17rem 0;
  width:90%;
  display: flex;
  justify-content: space-between;
  .honor-sub-left-div{
    width:50%;
  }
  .honor-sub-right-div{
    width:45%;
  }

  img{
    height:50rem;
    width:100%;
    object-fit: cover;
  }
}

.honor-sub-2{
  margin:17rem 0;
  align-items: center;
  width:90%;
  display: flex;
  justify-content: space-between;
  .honor-sub-left-div{
    width:45%;
  }
  .honor-sub-right-div{
    width:50%;
  }

  img{
    height:50rem;
    width:100%;
    object-fit: cover;
  }
}

.honor-sub-3{
  margin:17rem 0;
  width:90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .honor-sub-left-div{
    width:50%;
  }
  .honor-sub-right-div{
    width:45%;
  }

  img{
    height:50rem;
    width:100%;
    object-fit: cover;
  }
}
.honor-sub-4{
  margin:17rem 0;
  width:90%;
  display: flex;
  justify-content: space-between;
  .honor-sub-left-div{
    width:45%;
  }
  .honor-sub-right-div{
    width:50%;
  }

  img{
    height:50rem;
    width:100%;
    object-fit: cover;
  }
}
>>>.el-collapse-item__arrow{
  display: none;
}
//下方两个是打开和关闭的图标
.downArrow1{
  display: inline-block;
  width: 13px;
  height: 16px;
  background-image: url('../../../static/img/ic_collape_1.png');
  background-repeat: no-repeat;
}
.downArrow2{
  display: inline-block;
  width: 13px;
  height: 16px;
  background-image: url('../../../static/img/ic_collape_2.png');
  background-repeat: no-repeat;
}
//头部穿透，让头部内容在两端，本身固有属性是flex
 >>> .el-collapse-item__header {
        justify-content: space-between;
       
      }

@media screen and (max-width: 800px) {
  .top_item_div {
    padding: 0 1rem;
  }

  .top_item {
    height: 25rem;

    img {
      width: 5rem;
      margin: 2rem;
    }
  }

  .heading_div {
    margin-left: 5rem;
  }

  .icon_div {
    margin: 1rem;
  }

  .honor_div {
    padding: 3rem 1rem;
  }

  .honor_div2 {
    padding: 3rem 1rem;
  }

  .honor_div .honor_sub {
    div {
      margin: auto;
    }
  }
}
@media screen and (max-width: 1200px) {
  .tip-div{
    width:95%;
  }
  .honor-sub-1{
    margin:0;
    flex-direction: column;
    width: 100%;
    .honor-sub-left-div{
      width:100%;
    }
    .honor-sub-right-div{
      width:100%;
    }
  }
  .honor-sub-2{
    margin:0;
    flex-direction: column-reverse;
    width: 100%;
    .honor-sub-left-div{
      width:100%;
    }
    .honor-sub-right-div{
      width:100%;
    }
  }
  .honor-sub-3{
    margin:0;
    flex-direction: column;
    width: 100%;
    .honor-sub-left-div{
      width:100%;
    }
    .honor-sub-right-div{
      width:100%;
    }
  }
  .honor-sub-4{
    margin:0;
    flex-direction: column-reverse;
    width: 100%;
    .honor-sub-left-div{
      width:100%;
    }
    .honor-sub-right-div{
      width:100%;
    }
  }
}
</style>